const FILTER_REDUX_CONSTANT = {
  UPDATE_STAGE_CHECKBOX: 'UPDATE_STAGE_CHECKBOX',
  UPDATE_POTENTIAL_CHECKBOX: 'UPDATE_POTENTIAL_CHECKBOX',
  UPDATE_DEAL_VALUE: 'UPDATE_DEAL_VALUE',
  UPDATE_START_DATE_VALUE: 'UPDATE_START_DATE_VALUE',
  UPDATE_END_DATE_VALUE: 'UPDATE_END_DATE_VALUE',
  RESET_FILTER: 'RESET_FILTER',
};
export default FILTER_REDUX_CONSTANT;
